import '../license-filters';

export default (ctx, html) => html`
  <license-filters .licenseStatuses="${ctx.licenseStatuses}" product="${ctx.product}" license="${ctx.license}" .showLicenses="${ctx.showLicenses}" .showLicensesFromRoot="${ctx.showLicensesFromRoot}" licenseStatus="${ctx.licenseStatus}" @license-status-change="${ctx.filterUpdated}"></license-filters>
`;
